<template>
    <div class="quetaHome">
        <div class="list">
            <div>项目类型</div>
            <span v-for="(item,index) in projectDict.bg_project_category" :key="index" :class="{ active :cateinx == index }" @click="getCate(item,index)">{{ item.dict_label }}</span>
        </div>
       <div class="list">
                <div>项目类别</div>
                <span :class="{ active : lbinx == 100 }" @click="setlbList(1,100)">全部</span>
                <span v-for="(item,index) in projectCategoryList" :key="index" :class="{ active :lbinx == index }" @click="setlbList(item,index)">{{ item.dict_label }}</span>
        </div>
        <!-- <div class="list">
            <div>性质</div>
            <span :class="{ active : natinx == 10 }" @click="getNature(1,10)">全部</span>
            <span v-for="(item,index) in projectDict.bg_project_nature" :key="index" :class="{ active :natinx == index }" @click="getNature(item,index)">{{ item.dict_label }}</span>
        </div> -->
        <div class="list">
                <div>供求类型</div>
                <span :class="{ active : supplyIndex == 10 }" @click="setSupply(10,'')">全部</span>
                <span :class="{ active : supplyIndex == 1 }" @click="setSupply(1,'01')">项目出让</span>
                <span :class="{ active : supplyIndex == 2 }" @click="setSupply(2,'02')">项目求购</span>
        </div>
        <div class="queta-list" v-loading="loadingDiv" style="min-height:330px;">
            <div class="main-detail" v-for="(item,index) in dataList" :key="index">
                <div class="mainImg" @click="$router.push({ path:'/supplyDetails',query:{ id:item.supplyId } })" style="cursor:pointer"><img :src="item.pictureUrl[0]"></div>
                <div class="intro">
                    <div>
                        <div v-if="projectDict">
                            <span>{{ item.projectCategoryName }}</span>
                            <!-- <span>{{ $utils.getVal(projectDict.bg_project_nature,item.projectNature) }}</span> -->
                            <span>{{ item.supplyType=='01'?'项目出让':'项目求购' }}</span>
                        </div>
                    </div>
                </div>
            </div>   
            <div v-if="dataList.length==0" style="width:100%;height:330px;display:flex;justify-content: center;align-items: center;">
                  未查询到相关数据
            </div>     
        </div>   
        <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination>
    </div>   
   
</template>

<script>
export default {
    data(){
        return{
            projectDict:'',
            cateinx:10,
            natinx:10,
            supplyIndex:10,
            lbinx:100,
            params:{
                projectType:'01',
                projectCategory:'',//类别
                projectNature:'',//性质
                supplyType:'',
                publishStatus:'0',
                pageSize:10,
                pageNum:1
            },
            dataList:[],
            total:0,
            visible:false,
            currentItem:'',
            value:'',
            query:{
                invoiceStatus:'1',
                margin:'',
                quotationId:'',
            },
            loading:false,
            projectCategoryList:[],
            loadingDiv:false
        }
    },
    created(){
        //获取字典
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                    this.getCate(this.projectDict.bg_project_category[0],0)
                }else{
                     this.$message.info(res.msg)
                }
        })
        this.getDataList();
    },
    mounted(){
        this.$parent.current = '6';
    },
    methods:{
        getCate(item,index){
            this.cateinx = index;
            this.lbinx = 100;
            this.params.projectType = item.dict_value;
            this.getDataList();
            this.$https.get(`/portal/projectDict/getListByProjectType/${item.dict_value}`).then(res=>{
                 if(res.code == 200){
                     this.projectCategoryList = res.rows
                 }
            })
        },
        setlbList(item,index){
            this.params.projectCategory = item==1?'':item.dict_value;
            this.lbinx = index;
            this.getDataList();
        },
        getNature(item,index){
            this.natinx = index;
            this.params.projectNature = item.dict_value;
            this.getDataList();
        },
        setSupply(index,item){
            this.supplyIndex = index;
            this.params.supplyType = item;
            this.getDataList();
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
       
        getDataList(){
            this.loadingDiv = true;
            this.$https.get('/portal/entrust/queryList',{params:this.params}).then(res=>{
                this.loadingDiv = false;
                if(res.code == 200){
                    res.rows.forEach(item=>{
                        item.pictureUrl = item.pictureUrl.split(',');
                    })
                    this.dataList = res.rows
                    this.total = Number(res.total);
                }
            }).catch(error=>{
                    this.loadingDiv = false;
                    this.$message.error(res.msg)
            })
        },
    }
}
</script>

<style lang="less" scoped>
.quetaHome{
    width: 1300px;
    margin:0 auto;
    background: #fff;
    padding:20px 20px 50px 20px;
    .list{
        display: flex;
        flex-wrap:wrap;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        color:#333;
        div{
            margin-right:20px;
            font-weight: bold;
            padding:3px 5px;
        }
        .area{
            width: 1160px;
            font-weight: 500;
            line-height: 35px;
            padding: 0;
        }
        span{
            margin-right:10px;
            cursor: pointer;
            padding:3px 5px;
            border-radius: 2px;
        }
        .active{
            background: red;
            color:#fff;
        }
    }
    .queta-list{
        display: flex;
        flex-wrap:wrap;
        margin:20px 0;
        .main-detail{
            margin-right:20px;
            .mainImg{
                width: 400px;
                height: 270px;
                overflow: hidden;
                border:1px solid #eeeeee;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 400px;
                    height: auto;
                }
            }
            .intro{
                display: flex;
                justify-content: space-between;
                div{
                    &:nth-of-type(1){
                         line-height: 30px;
                         overflow: hidden;
                         span{
                             margin-right:30px;
                         }
                         div{
                             display: flex;
                             span{
                                 &:nth-of-type(1){
                                    max-width:200px;
                                    white-space:nowrap; 
                                    overflow:hidden; 
                                    text-overflow:ellipsis; 
                                    white-space:nowrap; 
                                 }
                             }
                         }
                    }
                    &:nth-of-type(2){
                        .ant-btn{
                            margin-top:13px;
                        }
                        
                    }
                }
            }
        }
    } 
    .address{
        width: 200px;
        overflow: hidden;
    }
}
</style>